import { Injectable } from '@angular/core';
import { ApModalService } from 'webcommon/core-ui';
import { FpMessagesReceivedDto } from 'webcommon/shared';
import { FPMessageReplyModalComponent } from './fp-message-reply-modal.component';

@Injectable({
  providedIn: 'root',
})
export class FPMessageReplyModalService {
  constructor(
    private apModalService: ApModalService,
  ) { }

  openModal(
    baseId: string,
    message: FpMessagesReceivedDto,
    readOnly: boolean = false,
    alertWarnings: string[] = [],
  ): Promise<boolean> {

    const initialState = {
      alertWarnings,
      baseId,
      message,
      readOnly,
    };

    const p = this.apModalService.showComponentModal(FPMessageReplyModalComponent, {
      class: 'emds-modal-full fp-modal',
      ignoreBackdropClick: true,
      initialState,
    });

    return p;
  }
}
